class ShowAll{
    constructor(el){
        this.el =el;

        this.allButton = document.querySelector('.AlliancePartners-partnerCards-displayButton');

        this.allButton.addEventListener('click', function() {

            let allButtonWrapper = el.querySelector('.AlliancePartners-partnerCards-displayWrapper');
            let hiddenCards = el.querySelectorAll('.AlliancePartners-partnerCards-card');
            let focusCard = document.getElementById('cardNumber9');
            
            // reveal cards
            hiddenCards.forEach(el => {
                el.classList.remove('hide');
            });
            // reset focus
            focusCard.focus();

            // Hide button
            allButtonWrapper.classList.add('hide');

        });
    } //end constructor
} // end class

const init = () => {

    let showAllClass = document.querySelector(".AlliancePartners-partnerCards"); // This class must be added to the gravity form in the WP Admin
  
    if (showAllClass) {
      new ShowAll(showAllClass);
    } 
  };

   // Init on initial page load
init();
